import React from "react";
import { Col, Row } from "react-bootstrap";
import { UploadsUrl } from "../../services/url";
import { GregorianToJalali2 } from "../../utilities/convertTime";
const Comment = (props) => {
  return (
    <div className='last-comment-lawyer'>
      <Row className='text-center comment-box-lawyer'>
        <Col xs={12} sm={3} className='pl-sm-0'>
          <div className='avatar-comment'>
            <img
              className='box-shadow'
              src={`${UploadsUrl}/${props.avatar}`}
              alt={props.name}
            />
          </div>
        </Col>
        <Col xs={12} sm={9} className='pr-sm-0'>
          <div>
            <div class='head-message-comment'>
              <div>
                <strong>{props.name}</strong>
              </div>

              <div>
                <span className='p-l-10'>ارسال در تاریخ</span>
                <span>{GregorianToJalali2(props.data)}</span>
              </div>
            </div>
            <div className='comment-text'>
              <p>{props.message}</p>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};
export default Comment;
